import React, { CSSProperties } from 'react'
import CardContent from 'components/Cards/CardContent'
import styles from 'components/Cards/Cards.module.scss'

type CardInfoProps = {
  title?: string
  subtitle?: string
  style?: CSSProperties
  children: React.ReactNode
}

function CardInfo(props: CardInfoProps) {
  const { title, subtitle, style, children } = props

  return (
    <CardContent sizeWidth='lg' className={styles.cardInfo} style={style}>
      {title && (
        <p className='m-0 whitespace-pre-line text-4xl font-bold text-pencatar-primary'>
          {title}
        </p>
      )}
      {subtitle && (
        <p className='mt-3 mb-0 whitespace-pre-line text-pencatar-primary'>
          {subtitle}
        </p>
      )}
      {title && (
        <div className='mt-5 mb-12 h-2 w-24 rounded-full bg-pencatar-secondary' />
      )}

      <div className={styles.rightContent}>{children}</div>
    </CardContent>
  )
}

export default CardInfo
